import { createContext, PropsWithChildren, useState } from "react";

export type AppRoute = {
    name: string,
    route: string,
    forceReload?: boolean,
}

export type RouteState = {
    routes: AppRoute[],
    setRoutes: (routes: AppRoute[]) => void,
}

export const RouteContext = createContext<RouteState>(null);

export const RouteContextProvider: React.FC<PropsWithChildren> = (props) => {

    const [routes, setRoutes] = useState<AppRoute[]>([]);

    const state: RouteState = {
        routes: routes,
        setRoutes,
    }

    return (<RouteContext.Provider value={state}>
        {props.children}
    </RouteContext.Provider>);
}